import Search16 from '@carbon/icons-react/es/search/16';
import React, { FC, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as SearchSvg } from 'assets/svgs/search.svg';
import { ReactComponent as TaskListSvg } from 'assets/svgs/task-list.svg';
import { Button } from 'components/atoms/button';
import { Input } from 'components/atoms/input';
import { useTranslation } from 'hooks/use-translation';
import { ProjectName, SearchInput, TaskName } from '../components';
import { TasksList } from '../task-list';
import { AdhockTaskListItem } from './use-add-adhoc-actions';

interface Props {
  searchText: string;
  setSearchText: (value: string) => void;
  loading: boolean;
  tasks: AdhockTaskListItem[];
  selectAllTasks: (selectAll: boolean) => void;
  onTaskSelect: (item: AdhockTaskListItem, selected: boolean) => void;
}

export const ActivitiesSubmittedLastWeek: FC<Props> = ({
  searchText,
  setSearchText,
  loading,
  tasks,
  selectAllTasks,
  onTaskSelect,
}) => {
  const searchInputRef = useRef<any>(null);

  const clearSearch = () => {
    setSearchText('');
    if (searchInputRef?.current) {
      searchInputRef.current.focus();
    }
  };
  const searchTaskPlaceholder = useTranslation(
    'timesheets.adhoc_activity.search_tasks',
  );

  return (
    <>
      <SearchInput>
        <Input
          ref={searchInputRef}
          value={searchText}
          placeholder={searchTaskPlaceholder}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <Search16 />
      </SearchInput>
      <TasksList
        title={
          <FormattedMessage id="timesheets.adhoc_activity.task_list_header" />
        }
        loading={loading}
        list={tasks}
        selectAll={selectAllTasks}
        onSelected={onTaskSelect}
        disabledTooltipContent={
          <FormattedMessage id="timesheets.adhoc_activity.already_added.disabled" />
        }
        renderItem={(task: AdhockTaskListItem) => (
          <>
            <TaskName>{task.activityName}</TaskName>
            <ProjectName>{task.project.label}</ProjectName>
          </>
        )}
        empty={
          searchText.length === 0 ? (
            <>
              <TaskListSvg />
              <div>
                <FormattedMessage id="timesheets.adhoc_activity.errors.no_tasks" />
              </div>
            </>
          ) : (
            <>
              <SearchSvg />
              <div>
                <FormattedMessage id="timesheets.tasks.filters.error.no_search_result_line_1" />
              </div>
              <div>
                <FormattedMessage id="timesheets.tasks.filters.error.no_search_result_line_2" />
              </div>
              <Button type="link" onClick={clearSearch}>
                <FormattedMessage id="timesheets.tasks.filters.actions.clear_search" />
              </Button>
            </>
          )
        }
      />
    </>
  );
};
